import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService {

  constructor(private toastr: ToastrService,) { }

  errorHandler(error) {
        if (error.status === 500) {
          this.toastr.error('Something went wrong. Please try again or contact support if the issue persists.');
        }
  }

}
